import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {goToPage} from '../saleJetBlockSlice';
import {createSaleAsync} from '../saleBlockAsyncThunk';
import SaleLoader from 'app/Components/Shared/SaleLoader/SaleLoader';

const CreateSaleInProcess = (props) => {
  // Use URL string (not loader.React) so Image renders <img> and CSS frame animation works.
  // Resolve theme CSS vars into the SVG markup for Cellcom / Golan colors.

  useEffect(() => {


    window.setTimeout(() => {
        props.createSaleAsync();
    }, 5000);
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'>עוד כמה רגעים מסיימים</h1>
    </div>
  );

  let currentPageView = (
    <div className='loader-wrapper'>
        <SaleLoader />
    </div>
  );

  return (
    <div className='slideAnimation create-sale-in-process-page'>
      {currentPageHeadline}
      <div className='sale-page-content'>{currentPageView}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
  };
};

const mapDispatchToProps = {
  goToPage,
  createSaleAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateSaleInProcess);
